import { render, staticRenderFns } from "./SlideDeckAdminHeader.vue?vue&type=template&id=156f03e8&scoped=true"
import script from "./SlideDeckAdminHeader.vue?vue&type=script&lang=ts"
export * from "./SlideDeckAdminHeader.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckAdminHeader.vue?vue&type=style&index=0&id=156f03e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f03e8",
  null
  
)

export default component.exports